export default {"src":"/_next/static/media/NEAR.adafe303.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};